import { Fetcher } from '@ajaibid/utils';

import { defineHeaders } from './headers';
import { logFetchError } from './logger';
import waitRefreshToken from './session/waitRefreshToken';
import { refreshPinTokenFn } from './session/refreshPintoken';
import { getPinToken } from './token';

/**
 * @typedef {import('@ajaibid/utils/dist/utils/fetcher/Fetcher').beforeFetcherInterceptor} beforeFetcherInterceptor
 * @typedef {import('@ajaibid/utils/dist/utils/fetcher/Fetcher').afterFetcherInterceptor} afterFetcherInterceptor
 */

export default function makeFetcher() {
  /**
   * @type {beforeFetcherInterceptor}
   */
  const beforeInterceptor = async (getConfig) => {
    const config = getConfig();
    if (config?.meta?.isUsingPinToken) {
      config.headers.Authorization = `jwt ${getPinToken()}`;
    }
    if (!config?.meta?.isRefreshToken) {
      await waitRefreshToken();
    }

    window.pendingFetch += 1;

    return config;
  };

  /**
   * @type {afterFetcherInterceptor}
   */
  const afterInterceptor = async (err, result) => {
    window.pendingFetch -= 1;

    if (err?.response?.status === 401) {
      await refreshPinTokenFn();
    }

    if (err) {
      logFetchError(err);
      throw err;
    }

    return result;
  };

  return Fetcher({
    headers: defineHeaders,
    baseURL: process.env.API_URL,
    interceptor: { before: beforeInterceptor, after: afterInterceptor },
  });
}
